import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Activate from "@/pages/Activate";
import TrainOnline from "@/pages/TrainOnline";
import BookEvaluation from "@/pages/BookEvaluation";
import Memberships from "@/pages/Memberships";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Platform from "@/pages/Platform";
import WelcomePortal from "@/pages/WelcomePortal";
import AthleteDashboard from "@/pages/AthleteDashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import CoachDashboard from "@/pages/CoachDashboard";
import OrgDashboard from "@/pages/OrgDashboard";
import TrackCoachDashboard from "@/pages/TrackCoachDashboard";
import TrackOrgDashboard from "@/pages/TrackOrgDashboard";

function Dashboard() {
  const { user } = useAuth();
  switch (user?.role) {
    case "admin": return <Platform />;
    case "athlete": return <AthleteDashboard />;
    case "parent": return <ParentDashboard />;
    case "coach": return <CoachDashboard />;
    case "org": return <OrgDashboard />;
    case "track_coach": return <TrackCoachDashboard />;
    case "org_admin": return <TrackOrgDashboard />;
    default: return <WelcomePortal />;
  }
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/train-online" element={<TrainOnline />} />
            <Route path="/online-coaching" element={<TrainOnline />} />
            <Route path="/book-evaluation" element={<BookEvaluation />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/activate" element={<Activate />} />
            <Route
              path="/platform"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/admin" element={<Navigate to="/platform" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
